module.exports = __webpack_public_path__ + "static/media/OS9.2cba593d.svg";